module.exports = __webpack_public_path__ + "static/media/KkGettingDirectionsDDO.ef1fe68b.pdf";